"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _Functions = require("../core/Functions");

var ActiveProvider =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ActiveProvider, _React$Component);

  function ActiveProvider(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ActiveProvider);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ActiveProvider).call(this, props));
    _this.state = {
      active: false
    };
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ActiveProvider, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mouseup', this._handleWindowMouseUp);
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(evt) {
      var _this2 = this;

      (0, _Functions.callIfPossible)(this.props.onMouseDown, evt);
      this.setState({
        active: true
      });

      this._handleWindowMouseUp = function () {
        _this2.setState({
          active: false
        });

        window.removeEventListener('mouseup', _this2._handleWindowMouseUp);
      };

      window.addEventListener('mouseup', this._handleWindowMouseUp);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(evt) {
      (0, _Functions.callIfPossible)(this.props.onKeyDown, evt);
      var key = evt.key;
      if (key !== 'Enter' && key !== ' ') return;
      this.setState({
        active: true
      });
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(evt) {
      (0, _Functions.callIfPossible)(this.props.onKeyUp, evt);
      var key = evt.key;
      if (key !== 'Enter' && key !== ' ') return;
      this.setState({
        active: false
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(evt) {
      (0, _Functions.callIfPossible)(this.props.onKeyUp, evt);
      if (this.state.active) this.setState({
        active: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          activeProp = _this$props.active;
      var active = this.state.active;
      return children({
        active: activeProp != null ? activeProp : active,
        onMouseDown: this.handleMouseDown,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onBlur: this.handleBlur
      });
    }
  }]);
  return ActiveProvider;
}(_react.default.Component);

ActiveProvider.displayName = 'ActiveProvider';
var _default = ActiveProvider;
exports.default = _default;
module.exports = exports.default;